import { createFileRoute } from "@tanstack/react-router";
import { BillsPage } from "../features/bill/bills-page";
import { Require } from "../features/require";

/** More > Bills (P4-T20). */
export const Route = createFileRoute("/more/bills/")({ component: Page });

function Page() {
	return (
		<Require permission="bill.create">
			<BillsPage />
		</Require>
	);
}
